$(function () {

	$('.header-menu-btn').on('click', function () {
		toggle_header_menu();
		sub_menu_hide();
		return false;
	});

	$('.js-hide-header-mobile-menu').on('click', function () {
		$('.header-mobile-menu').removeClass('active');
		close_mobile_menu();
		bodyUnLock();
	});

	if (is_desktop && !is_tablet_big) {
		$('.header-menu').on('mouseleave', function () {
			sub_menu_hide();
		});

		$('.header-menu-list>li>a').on('mouseenter', function () {
			let id = $(this).attr('data-child-id'),
				menu = $(id);

			sub_menu_open(menu);
		});
	}

	$('.header-menu-sub-itm>a').on('mouseenter', function () {
		let other_img = $(this).closest('.header-menu-sub').find('.header-menu-sub__img'),
			img = $(this).siblings('.header-menu-sub__img');

		other_img.removeClass('active');
		img.addClass('active');

		gsap.to(other_img, {opacity: 0, duration: .3});
		gsap.to(img, {opacity: 1, duration: .3});
	});

	if (is_tablet_big) {
		$('.header-menu-list>li>a').on('click', function () {
			let id = $(this).attr('data-child-id'),
				menu = $(id);

			$(this).toggleClass('open');
			$(this).parent().siblings('li').find('a').removeClass('open');

			if ($(this).hasClass('open')) {
				sub_menu_open(menu);
			} else {
				sub_menu_hide();
			}

		});

		$(document).click(function (event) {
			if ($(event.target).closest(".header-menu-list,.header-menu-subs").length) {
				return;
			}

			$('.header-menu-list a').removeClass("open");

			sub_menu_hide();
		});
	}


	$('.header-mobile-menu-list .has-child a').on('click', function () {
		var li = $(this).parent(),
			ul = li.find('ul');

		li.toggleClass('active');

		if (li.hasClass('active')) {
			gsap.to(ul, {opacity: 1, height: 'auto', duration: .3});
		} else {
			gsap.to(ul, {opacity: 0, height: '0', duration: .3});
		}

	});


	$('.js-close-cookie-popup').on('click', function () {
		$('.cookie-popup').addClass('close');
		document.cookie = "cookie=true; max-age=3600*24*30; path=/";

		setTimeout(function () {
			$('.cookie-popup').remove();
		}, 600);

		return false;

	});

	if (is_tablet) {
		$('.header-menu-subs').remove();
	}

});

var header_timeout_close, header_timeout_open,
	header_menu_tl = gsap.timeline(),
	can_header_open = true,
	can_header_close = true;

function toggle_header_menu() {

	$('.header-mobile-menu').toggleClass('active');

	if (is_tablet) {
		bodyLock();
	}

	if ($('.header-mobile-menu').hasClass('active')) {
		open_mobile_menu();
	} else {
		close_mobile_menu();
	}

	if (is_tablet) {
		return false;
	}

	$('.header-menu').toggleClass('active');

	if ($('.header-menu').hasClass('active')) {
		open_header_menu();
	} else {
		close_header_menu();
	}
}

function open_header_menu() {
	if (!can_header_open) {
		return false;
	}
	let time = 300;

	can_header_open = false;

	header_menu_tl.clear();

	header_menu_tl = gsap.timeline();

	if (is_tablet && !is_tablet_only) {
		time = 900;


		header_menu_tl.to($('.header__logo'), {
			opacity: 1,
			duration: 0.3,
		});


		header_menu_tl.to($('.header .header-content'), {
			width: '100%',
			duration: 0.3,
			ease: "power3.out"

		});

		header_menu_tl.to($('.gamburger'), {
			width: 40,
			duration: 0.07,
			x: 0,
			ease: "power3.out"
		}, "<");
	} else {
		let menu = $('.header-menu-list');

		header_menu_tl.to(menu, {width: '450px', duration: .3}, 0);

		if (is_tablet_big) {
			if ($('.front_page').length === 0) {
				header_menu_tl.to($('.header__logo'), {
					opacity: 1,
					duration: 0.3,

				}, '<');
			}

			setTimeout(function () {
				if ($('body').hasClass('fp-viewing-0')) {
					gsap.to($('.header__logo'), {
						opacity: 1,
						duration: 0.3,
					});
				}
			}, 200);
		}

		header_menu_tl.to($('.header-menu-list > li'), {opacity: 1, duration: .3});
		$('.header-menu').addClass('active');

	}


	clearTimeout(header_timeout_open);
	header_timeout_open = setTimeout(function () {
		can_header_open = true;
	}, time);
}

function close_header_menu() {
	if (!can_header_close) {
		return false;
	}
	let time = 300;

	can_header_close = false;

	header_menu_tl.clear();
	header_menu_tl = gsap.timeline();

	if (is_tablet && !is_tablet_only) {
		time = 1000;

		header_menu_tl.to($('.header__logo'), {
			opacity: 0,
			duration: 0.3,

		});
		header_menu_tl.to($('.header .header-content'), {
			width: 55,
			duration: 0.5,
			ease: "power3.out"

		});
		header_menu_tl.to($('.gamburger'), {
			width: 30,
			duration: 0.05,
			x: 10,
			ease: "power3.out",
		}, "<-.2");
	} else {
		let menu = $('.header-menu-list');

		header_menu_tl.to($('.header-menu-list > li'), {opacity: 0, duration: .1, stagger: 0.03})
		header_menu_tl.to(menu, {
			width: '56px',
			duration: .3
		}, .15);

		if (is_tablet_big) {
			header_menu_tl.to($('.header__logo'), {
				opacity: 0,
				duration: 0.3,

			}, '<');
		}
		$('.header-menu').removeClass('active');


		//sub_menu_hide();
	}

	clearTimeout(header_timeout_close);
	header_timeout_close = setTimeout(function () {
		can_header_close = true;
	}, time);
	sub_menu_hide();
}

function sub_menu_hide(menu) {
	let tl = gsap.timeline();

	if (is_tablet) {
		return false;
	}


	if (!menu) {
		menu = $('.header-menu-sub');
	}

	menu.removeClass('active');

	tl.to(menu, {opacity: 0, duration: .3});
	tl.to(menu, {transform: 'translateY(-30px)', duration: .3}, 0);
	tl.to(menu, {'backdrop-filter': 'blur(0)', '-webkit-backdrop-filter': 'blur(0)', duration: .2}, .1);
}

function sub_menu_open(menu) {
	let tl = gsap.timeline();

	if (menu.hasClass('active')) {
		return false;
	}

	$('.header-menu-sub').removeClass('active');

	if (menu.length > 0) {
		menu.addClass('active');

		sub_menu_hide($('.header-menu-sub:not(.active)'));

		tl.to(menu, {transform: 'translateY(0px)', opacity: 1, duration: .3}, 0);
		tl.to(menu, {
			'backdrop-filter': 'blur(15px)',
			'-webkit-backdrop-filter': 'blur(15px)',
			duration: .2
		}, .1);

		tl.fromTo(menu.find('li a,.header-menu-sub__sep'), {y: -15, opacity: 0}, {y: 0, opacity: 1}, '<')
		tl.fromTo(menu.find('.header-menu-sub__img.active'), {opacity: 0}, {opacity: 1, duration: .6}, '<')


	} else {
		sub_menu_hide();
	}
}

function open_mobile_menu() {
	var tl = gsap.timeline(),
		menu = $('.header-mobile-menu');

	if (!is_tablet) {
		return false;
	}

	tl.to(menu, {opacity: 1, duration: .3});
	tl.fromTo(menu.find('.js-hide-header-mobile-menu'), {opacity: 0}, {opacity: 1, duration: .3});
	tl.fromTo(menu.find('.header-mobile-menu-list>li'),
		{opacity: 0, x: -10},
		{opacity: 1, x: 0, duration: .25, stagger: .15},
		"<"
	);
	tl.fromTo(menu.find('.header-mobile-menu-btn'),
		{opacity: 0, y: 10},
		{opacity: 1, y: 0, duration: .3},
		">-0.2"
	);

}

function close_mobile_menu() {
	var menu = $('.header-mobile-menu');

	if (!is_tablet) {
		return false;
	}

	gsap.to(menu, {opacity: 0, duration: .3});
	gsap.to(menu.find('.js-hide-header-mobile-menu'), {opacity: 0, duration: .3});
	gsap.to(menu.find('.header-mobile-menu-list>li'), {opacity: 0, x: -10, duration: .4},);
	gsap.to(menu.find('.header-mobile-menu-btn'), {opacity: 0, y: 10, duration: .3});
}